import tw from 'twin.macro'
import { styled } from '@mui/material/styles'

export const ItemContainer = styled('div')`
  ${tw`p-6 bg-white border border-gray-200 shadow-sm rounded-xl`}
`
export const ItemNumber = styled('div')`
  word-break: break-word;
  ${tw`text-display-md-semibold text-gray-900`}
`
export const ItemTitle = styled('div')`
  ${tw`text-sm-medium text-gray-600 mb-2`}
`
